const doc = [({"en":({"js":({"admin":({"activity_participants":({"requested_unregister":({"requested_unregister":"Request unregister"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;